/* unplugin-vue-components disabled */import script from "./psychology-course.vue?vue&type=script&setup=true&lang=ts"
export * from "./psychology-course.vue?vue&type=script&setup=true&lang=ts"

import "./psychology-course.vue?vue&type=style&index=0&id=523b8fcf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523b8fcf"]])

export default __exports__